import { z } from "zod";

import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import MaterialChip from "#modules/quoteRequestLines/view/MaterialChip";
import { getSurfaceTreatment } from "#modules/similarPart/domain/getSurfaceTreatment";
import { SearchSimilarPartDto } from "#modules/similarPart/infra/searchSimilarParts.api";
import { DimensionChip } from "#shared/view/components/DimensionChip";
import { Group } from "#shared/view/components/Group";
import { SurfaceTreatmentChip } from "#shared/view/components/SurfaceTreatmentChip";
import {
  getMaterialGrade,
  MaterialGradeType,
  ProcessStepSchema,
  QuoteRequestLineSchema,
} from "shared";
type Props = {
  part: Omit<SearchSimilarPartDto, "quoteRequestLines"> & {
    cosineSimilarity?: number;
    quoteRequestLines?: (z.infer<typeof QuoteRequestLineSchema> & {
      processSteps?: z.infer<typeof ProcessStepSchema>[];
    })[];
  };
  quoteRequestLineMaterialGrade?: MaterialGradeType | null;
  dimensionsUpdatable?: boolean;
  quoteRequestLine?: QuoteRequestLineDto | undefined | null;
  onSubmitPartDimensions?: () => void;
};

export const PartChips = ({
  part,
  quoteRequestLineMaterialGrade,
  dimensionsUpdatable = false,
  quoteRequestLine,
  onSubmitPartDimensions,
}: Props) => {
  const surfaceTreatment = getSurfaceTreatment(part.quoteRequestLines);

  const materialGrade = getMaterialGrade({
    quoteRequestLineMaterialGrade,
    partMaterialGrade: part.materialGrade,
  });

  return (
    <Group
      gap={"xxs"}
      align="flex-start"
      style={{
        overflow: "hidden",
      }}
    >
      {materialGrade && <MaterialChip materialGrade={materialGrade} />}

      <DimensionChip
        part={part}
        quoteRequestLine={quoteRequestLine}
        updatable={dimensionsUpdatable}
        onSubmitPartDimensions={onSubmitPartDimensions}
      />

      {surfaceTreatment && <SurfaceTreatmentChip surfaceTreatment={surfaceTreatment} />}
    </Group>
  );
};
